import { renderTimes, SkeletonGroup } from '@shared/components/Skeleton';
import { SpacingStack, TextV2 } from '@withjoy/joykit';
import React from 'react';
import { Accordion, Item, Section } from './components';
import { useRegistryChecklistController } from './controller';
import { StyledChecklistWrapper, StyledChecklistSectionWrapper, StyledChecklistLoader, styles } from './styles';
import { ParticlesLoader, Spinner } from './components/Loader';
import { useTranslation } from '@shared/core';

export const RegistryChecklist = ({ eventId, onCloseDrawer }: { eventId: string; onCloseDrawer: () => void }) => {
  const { checklistSections, handleOnToggle, openedSectionId, sectionData, handleOnCheckItem, getSectionLoading, checklistLoading, createChecklistLoading } =
    useRegistryChecklistController(eventId);
  const { t2 } = useTranslation('sharedComponents');
  const { buildingChecklist } = t2('registryGiftBasket', 'giftOverlay', 'checklist');

  return (
    <>
      {createChecklistLoading && (
        <StyledChecklistLoader __css={styles.checklistLoader}>
          <ParticlesLoader />
          <Spinner />
          <TextV2 typographyVariant="hed3">{buildingChecklist}</TextV2>
        </StyledChecklistLoader>
      )}
      <StyledChecklistWrapper
        paddingBottom={6}
        paddingRight={6}
        paddingLeft={6}
      >
        {/* Hidden Progress Bar: CTP-809 */}
        {/* <SpacingStack spacing={7}>
        <GiftProgress isLoading={checklistLoading} progressPercentage={progressPercentage} title={title()} />
        <StyledDivider __css={styles.divider} />
      </SpacingStack> */}
        <SkeletonGroup
          isReady={!checklistLoading}
          placeholder={renderTimes(12, idx => (
            <Section.Skeleton
              borderBottom="1px solid"
              borderColor="mono3"
              key={idx}
            />
          ))}
        >
          <StyledChecklistSectionWrapper>
            {checklistSections
              ? checklistSections.map(section => {
                  return (
                    <Accordion key={section.id}>
                      <Accordion.VisibleContent
                        handleOnToggle={() => {
                          handleOnToggle(section.id, section.sectionTitle);
                        }}
                        isOpen={openedSectionId === section.id}
                      >
                        <Section
                          sectionTitle={section.sectionTitle}
                          iconUrl={section.thumbnail?.url}
                          targetCount={section.sectionProgress.totalCount}
                          completedCount={section.sectionProgress.checkedCount}
                        />
                      </Accordion.VisibleContent>
                      <Accordion.CollapsedContent isOpen={openedSectionId === section.id}>
                        <SpacingStack spacing={5}>
                          {getSectionLoading
                            ? renderTimes(section.sectionProgress.totalCount, idx => <Item.Skeleton key={idx} />)
                            : sectionData?.id === openedSectionId
                              ? [...sectionData.checklistItems]
                                  .sort((a, b) => a.sortKey - b.sortKey)
                                  .map(item => {
                                    return (
                                      <Item
                                        handleOnCheckItem={isChecked => handleOnCheckItem(item, isChecked, section.id)}
                                        key={item.id}
                                        isCheckable={item.isCheckable}
                                        itemTitle={item.title}
                                        isCompleted={item.isChecked}
                                        productThumbnailUrl={item.thumbnail?.url}
                                        productTitle={item.subTitle}
                                        ctaUrl={item.completeCTAUrlPath}
                                        onCloseDrawer={onCloseDrawer}
                                      />
                                    );
                                  })
                              : null}
                        </SpacingStack>
                      </Accordion.CollapsedContent>
                    </Accordion>
                  );
                })
              : null}
          </StyledChecklistSectionWrapper>
        </SkeletonGroup>
      </StyledChecklistWrapper>
    </>
  );
};
